//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Fingerprint2 from 'fingerprintjs2'
import riskModule from '~/components/common/riskModuleFxeye.vue'
import wikiHead from '~/components/common/wikiHead.vue'
import wikiFooter from '~/components/common/wikiFooter.vue'
import chromePlugin from '~/components/common/chromePlugin.vue'
export default {
  name: 'WikiDefault',
  components: {
    'risk-module': riskModule,
    'wiki-head': wikiHead,
    'wiki-footer': wikiFooter,
    'chrome-plugin': chromePlugin
  },
  data () {
    return {
    }
  },
  head () {
    // 不显示hreflang页面-资讯详情页、教育文章详情页、百科详情页、交易商介绍详情页
    const show = this.$route.name == 'lang-newsdetail-id' || this.$route.name == 'lang-learn-id' || this.$route.name == 'lang-wikishow-id' || this.$route.name == 'lang-intro-id' || this.$route.name == 'lang-exposure-add.html'
    const canonicalshow = this.$route.name == 'lang-exposure-add.html'
    let ate = []
    let canonicalarr = []
    if (!show) {
      ate = [...this.alternate()]
    }
    if (!canonicalshow) canonicalarr = [...this.canonical()]

    let googleurl = ''
    if (this.$store.state.isWiki == '1' || this.$store.state.isWiki == '3') {
      googleurl = 'https://www.googletagmanager.com/gtag/js?id=UA-172151915-1'
    } else if (this.$store.state.isWiki == '2' || this.$store.state.isWiki == '4') {
      googleurl = 'https://www.googletagmanager.com/gtag/js?id=UA-172113747-5'
    }
    const icon = (this.$store.state.isWiki == '1' || this.$store.state.isWiki == '3') ? 'https://resources1.interface003.com/web20/img/favicon-wikifx.ico' : 'https://resources1.interface003.com/web20/img/favicon-fxeye.ico'
    const rptxt = {
      src: 'https://resources1.interface003.com/web20/js/rptxt.js',
      body: false,
      async: true
    }
    const eeeoeee = {}
    let allga = {} // 新的ga统计代码，不限域名，所有的都有
    if (this.$store.state.myCountry != 'cn') {
      allga = {
        src: 'https://www.googletagmanager.com/gtag/js?id=G-EH7WFXEEHY',
        body: false,
        async: true
      } // 新的ga统计代码，不限域名，所有的都有
    }

    const chost = this.$store.state.cookieHost
    if (chost.includes('wikifx.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxact.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee2.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyetips.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee3.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifx.vip')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee4.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye2017.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee5.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifx2.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee6.js',
        body: false,
        async: true
      })
    } else if (chost.includes('shareowen.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee7.js',
        body: false,
        async: true
      })
    } else if (chost.includes('mchgi.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee8.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifx25.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee9.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye25.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee10.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyema.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee11.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyecn.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee12.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxvn.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee13.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxvi.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee14.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxen.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee15.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxzh.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee16.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxka.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee17.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxcn.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee18.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye110.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee19.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye123.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee20.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye777.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee21.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye688.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee22.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee23.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyevn.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee24.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyevi.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee25.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye555.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee26.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeye2021.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee27.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyefx.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee28.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyevps.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee29.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifx.hk')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee30.js',
        body: false,
        async: true
      })
    } else if (chost.includes('wikifxtips.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee31.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyevip.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee33.js',
        body: false,
        async: true
      })
    } else if (chost.includes('fxeyeka.com')) {
      Object.assign(eeeoeee, {
        src: '/contentgj/eeeoeee34.js',
        body: false,
        async: true
      })
    }

    return {
      htmlAttrs: {
        lang: this.$route.params.lang,
        dir: this.$route.params.lang == 'ar' ? 'rtl' : 'ltr'
      },
      // title: '\u200F' + 'title',
      link: [...ate, ...canonicalarr, { rel: 'icon', type: 'image/x-icon', href: icon }],
      script: [
        eeeoeee,
        rptxt,
        allga,
        {
          charset: 'utf-8',
          src: googleurl,
          body: false,
          async: true
        }]
    }
  },
  created () {
  },
  mounted () {
    // this.$Cookie.set('DJkdikKMG','i37J4bZ%252bQ487979vIXUzkQ%253d%253d%257cFX1590815850%257chttps%253a%252f%252fimg.fx696.com%252f%252fInit%252f900_1.png_wiki-template-global%257c4436250823%257c14eb21cc2dcc77b2c4b97dd5b3ca2c19')
    // this.$Cookie.set('DJkdikKMG','i37J4bZ%252bQ487979vIXUzkQ%253d%253d%257cFX1590815850%257chttps%253a%252f%252fimg.fx696.com%252f%252fInit%252f900_1.png_wiki-template-global%257c4436250823%257c14eb21cc2dcc77b2c4b97dd5b3ca2c19')
    if (!this.$Cookie.get('wiki-bfp')) this.setBfp() // 浏览器指纹码
    else this.$store.commit('setlinkuser', this.$Cookie.get('wiki-bfp'))
    this.Loginoperation() // 登录相关操作
    const _this = this
    this.setIsMobile()
    window.onresize = function () { // 定义窗口大小变更通知事件
      _this.setIsMobile()
    }

    // this.$nextTick(() => {
    //   this.setImg()
    //   this.scrollImg()
    // })
    // this.scrollImg()
  },
  methods: {
    Loginoperation () { // 实现登录操作
      // console.log(123);
      const that = this
      window.addEventListener('message', function (e) {
        // console.log(e.data, 22234)
        const ret = e.data
        if (ret != null) {
          if (ret.op_type == 'reload') {
            // console.log('reload', 33333)
            window.location.reload()
          } else if (ret.op_type == 'close') {
            // console.log('close', 5555)
            that.loginShow = false
          } else if (ret.op_type == 'opennew' && ret.url) {
            // console.log('opennew', 4444)
            if (ret.url.includes('##')) {
              const urlCur = window.location.href
              window.location.href = ret.url.replace('##', urlCur)
            } else {
              window.location.href = ret.url
            }
          }
        }
      })
    },
    setBfp () { // 浏览器指纹码
      Fingerprint2.get((components) => { // 浏览器指纹码
        const values = components.map(function (component, index) {
          if (index == 0) { // 把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
            return component.value.replace(/\bNetType\/\w+\b/, '')
          }
          return component.value
        })
        // 生成最终id murmur
        const murmur = Fingerprint2.x64hash128(values.join(''), 31)
        // const { host: hostS = '' } = this.$store.state
        // const url = hostS ? (hostS.includes('3000') ? hostS.split(':')[0] : (hostS.includes('443') ? hostS.split(':')[0].substr(hostS.indexOf('.')) : hostS.substr(hostS.indexOf('.')))) : 'www.${this.$store.state.newhost}.com'
        // const url = hostS ? (hostS.includes(':') ? hostS.split(':')[0] : hostS.substr(hostS.indexOf('.'))) : 'www.${this.$store.state.newhost}.com'
        const now = new Date(new Date(new Date().getTime()).setFullYear(9998, 0, 0))
        this.$Cookie.set('wiki-bfp', murmur, { expires: now, path: '/', domain: this.$store.state.cookieHost })
        this.$store.commit('setlinkuser', murmur)
      })
    },
    setIsMobile () {
      // console.log(, 888)
      if (document.documentElement.clientWidth > (799 - this.getScrollbarWidth())) {
        this.$store.commit('setMobile', false)
      } else {
        this.$store.commit('setMobile', true)
      }
    },
    scrollImg () { // 图片懒加载滚动事件
      window.addEventListener('scroll', this.setImg)
    },
    setImg () { // 图片懒加载图片处理
      const ele = document.getElementsByClassName('common-img')
      const windowHeight = window.innerHeight
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      for (let i = 0; i < ele.length; i++) {
        const top = ele[i].offsetTop > 0 ? ele[i].offsetTop : ele[i].parentNode.offsetTop
        if (top <= windowHeight + scrollTop) {
          ele[i].setAttribute('src', ele[i].getAttribute('xsrc'))
        }
      }
    },
    getScrollbarWidth () {
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    }
  }
}
